module.exports = "<div seedelement class=\"lui-interactive\">\n  <slot name=\"menu\"></slot>\n  <span class=\"text\">\n    <slot></slot>\n  </span>\n  <svg class=\"chevron chevron--down\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n    <path d=\"M8,9.17l4.59-4.58L14,6,8,12,2,6,3.41,4.59Z\"/>\n  </svg>\n  <svg class=\"chevron chevron--up\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n    <path d=\"M8,6.83,3.41,11.41,2,10,8,4l6,6-1.41,1.41Z\"/>\n  </svg>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-tabbar/theme/lui-tab.html
// module id = 343
// module chunks = 0 1 6